import {
  GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_REQUEST,
  GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_SUCCESS,
  GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getshippedDetailByPaymentMethod = (token, values) => (dispatch) => {
  dispatch({ type: GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_REQUEST });
  const newData = {
    date_from: moment(values.from_date).format("YYYY-MM-DD"),
    date_to: moment(values.to_date).format("YYYY-MM-DD"),
  };

  return axios({
    method: "POST",
    url: `${BASEURL}getAll/OMSShippedPaymentMethod`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_ERROR,
        payload: [],
      });
    });
};
